import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Globe, Shield, TrendingUp, Clock } from 'lucide-react';
import { COMPANY_INFO, WHY_CHOOSE_US } from '../data/mockData';
import { Button } from '../components/ui/button';

const Home = () => {
  const features = [
    {
      icon: Globe,
      title: "Global Network",
      description: "Extensive network of verified suppliers across continents"
    },
    {
      icon: Shield,
      title: "Quality Assured",
      description: "International standards and rigorous quality control"
    },
    {
      icon: TrendingUp,
      title: "Competitive Pricing",
      description: "Cost-efficient procurement and transparent pricing"
    },
    {
      icon: Clock,
      title: "Timely Delivery",
      description: "Reliable logistics ensuring on-time delivery worldwide"
    }
  ];

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-badge">Global Commodities Trading</div>
          <h1 className="hero-title">{COMPANY_INFO.name}</h1>
          <p className="hero-subtitle">{COMPANY_INFO.tagline}</p>
          <p className="hero-description">
            Connecting producers and buyers worldwide with premium metals, minerals, fuels, 
            and strategic raw materials through trusted partnerships and excellence in service.
          </p>
          <div className="hero-buttons">
            <Link to="/minerals-metals">
              <Button className="btn-primary">
                Explore Products
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
            <Link to="/contact">
              <Button className="btn-secondary">Contact Us</Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features-section">
        <div className="section-container">
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon-wrapper">
                  <feature.icon className="feature-icon" size={32} />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Why Choose M 360 Commodities</h2>
            <p className="section-subtitle">
              We don't just supply materials—we build partnerships
            </p>
          </div>
          <div className="why-choose-grid">
            {WHY_CHOOSE_US.map((item, index) => (
              <div key={index} className="why-choose-card">
                <div className="why-choose-number">{index + 1}</div>
                <h3 className="why-choose-title">{item.title}</h3>
                <p className="why-choose-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Showcase */}
      <section className="products-showcase-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Our Product Range</h2>
            <p className="section-subtitle">
              Comprehensive supply of premium commodities for global industries
            </p>
          </div>
          <div className="products-showcase-grid">
            <Link to="/minerals-metals" className="product-showcase-card">
              <div className="product-showcase-content">
                <h3 className="product-showcase-title">Minerals & Metals</h3>
                <p className="product-showcase-description">
                  Copper, Lithium, Coltan, Zinc, Manganese, Gold, and more
                </p>
                <div className="product-showcase-link">
                  Explore Range <ArrowRight size={18} />
                </div>
              </div>
            </Link>
            <Link to="/oil-gas" className="product-showcase-card">
              <div className="product-showcase-content">
                <h3 className="product-showcase-title">Oil & Gas</h3>
                <p className="product-showcase-description">
                  EN590 Diesel, Jet Fuel A, D6 Fuel, Engine Oil
                </p>
                <div className="product-showcase-link">
                  Explore Range <ArrowRight size={18} />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Partner With Us?</h2>
          <p className="cta-description">
            Let's discuss your commodity requirements and build a lasting partnership
          </p>
          <Link to="/contact">
            <Button className="btn-cta">
              Get In Touch
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
